module.exports = __webpack_public_path__ + "8f352973fb9d2921c8444121d504fa09.pdf";